import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import { register as registerServiceWorker } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);

registerServiceWorker({
  onSuccess: () => {
    // eslint-disable-next-line no-console
    console.info("PWA is ready for offline use.");
  },
  onUpdate: () => {
    // eslint-disable-next-line no-console
    console.info("A new app version is available. Refresh to update.");
  },
});
